class CookieConsent extends HTMLElement {
  constructor() {
    super();

    this.cookieName = 'cookie-consent';
    this.cookieVersion = '1';
    this.cookieMaxAgeDays = 365;
    this._bound = false;

    const EU_COUNTRIES = [
      'AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IS','IE','IT',
      'LV','LI','LT','LU','MT','NL','NO','PL','PT','RO','SK','SI','ES','SE','GB','CH'
    ];

    const storedConsent = this.readCookie(this.cookieName);
    const isDesignMode = window.Shopify && window.Shopify.designMode;

    if (storedConsent && storedConsent.version === this.cookieVersion && !isDesignMode) {
      this.remove();
      return;
    }

    const showBanner = () => {
      if (this._bound) return;
      this._bound = true;

      this.style.display = 'block';

      const acceptBtn = this.querySelector('[data-accept-cookie]');
      const declineBtn = this.querySelector('[data-decline-cookie]');
      const manageBtn = this.querySelector('[data-manage-prefs]');
      const saveBtn = this.querySelector('[data-save-prefs]');
      const prefsPanel = this.querySelector('[data-prefs-panel]');

      if (prefsPanel) prefsPanel.hidden = true;

      if (acceptBtn) acceptBtn.addEventListener('click', (e) => this.handleConsent(e, {
        analytics: true, marketing: true, preferences: true
      }));
      if (declineBtn) declineBtn.addEventListener('click', (e) => this.handleConsent(e, {
        analytics: false, marketing: false, preferences: false
      }));
      if (manageBtn) manageBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (prefsPanel) prefsPanel.hidden = !prefsPanel.hidden;
      });
      if (saveBtn) saveBtn.addEventListener('click', (e) => {
        e.preventDefault();

        const prefs = {};
        this.querySelectorAll('[data-pref]').forEach((input) => {
          const key = input.getAttribute('data-pref');
          if (key === 'required') return;
          prefs[key] = input.checked;
        });

        const consent = {
          analytics: !!prefs.analytics,
          marketing: !!prefs.marketing,
          preferences: !!prefs.preferences,
          sale_of_data: false
        };

        this.writeCookie(this.cookieName, {
          decision: 'custom',
          version: this.cookieVersion,
          timestamp: Date.now(),
          consent
        });

        this.syncWithShopify(consent);

        if (prefsPanel) prefsPanel.hidden = true;

        document.dispatchEvent(new CustomEvent('cookie-consent:decided', {
          detail: { consent, version: this.cookieVersion, timestamp: Date.now(), final: false }
        }));
      });
    };

    const decideByRegion = () => {
      if (isDesignMode) {
        showBanner();
        return;
      }

      const region = window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.getRegion
        ? window.Shopify.customerPrivacy.getRegion()
        : '';
      const countryCode = region ? region.slice(0, 2) : '';

      if (countryCode && !EU_COUNTRIES.includes(countryCode)) {
        this.remove();
        return;
      }

      showBanner();
    };

    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (error) {
          showBanner();
          return;
        }
        decideByRegion();
      });
    } else {
      decideByRegion();
    }
  }

  writeCookie(cname, data) {
    const d = new Date();
    d.setTime(d.getTime() + this.cookieMaxAgeDays * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + d.toUTCString();
    const secure = location.protocol === 'https:' ? ';secure' : '';
    const value = encodeURIComponent(JSON.stringify(data));
    document.cookie = cname + '=' + value + ';' + expires + ';path=/;SameSite=Lax' + secure;
  }

  readCookie(cname) {
    const name = cname + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1);
      if (c.indexOf(name) === 0) {
        const raw = c.substring(name.length, c.length);
        try {
          const parsed = JSON.parse(decodeURIComponent(raw));
          if (parsed && typeof parsed === 'object' && parsed.version) {
            return parsed;
          }
        } catch (e) {
          return null;
        }
        return null;
      }
    }
    return null;
  }

  handleConsent(event, prefs) {
    event.preventDefault();

    const consent = {
      analytics: !!prefs.analytics,
      marketing: !!prefs.marketing,
      preferences: !!prefs.preferences,
      sale_of_data: false
    };

    const decision = (consent.analytics || consent.marketing || consent.preferences) ? 'custom' : 'declined';

    this.writeCookie(this.cookieName, {
      decision,
      version: this.cookieVersion,
      timestamp: Date.now(),
      consent
    });

    this.syncWithShopify(consent);
    this.remove();

    document.dispatchEvent(new CustomEvent('cookie-consent:decided', {
      detail: { consent, version: this.cookieVersion, timestamp: Date.now(), final: true }
    }));
  }

  syncWithShopify(consent) {
    if (window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.setTrackingConsent) {
      window.Shopify.customerPrivacy.setTrackingConsent(consent, (result) => {
        if (result && result.error) console.warn('Shopify consent sync failed:', result.error);
      });
    } else if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => {
        if (!err && window.Shopify.customerPrivacy) {
          window.Shopify.customerPrivacy.setTrackingConsent(consent);
        }
      });
    }
  }
}

customElements.define('cookie-consent', CookieConsent);